module.exports = __webpack_public_path__ + "img/zt3.b7003af6.png";